// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2jBG0","options":"AnswerScale_options__6c8_t","selected":"AnswerScale_selected__J5_dw"};